<template>
  <div class="wrap">
    <div class="order">
      <div class="key_visual addImg order">
        <div class="container">
          <p></p>
        </div>
      </div>

      <div class="order_con">
        <form name="order_info" @submit.prevent="validateDelivMsg">
          <!-- <form name="order_info"> -->
          <div class="container">
            <div class="my_info">
              <div class="info_title">구매자 정보</div>
              <div class="info">
                <div class="nl">
                  <div class="nl_1">이름</div>
                  <div class="nl_2">
                    <input
                      v-model="loadName"
                      class="input"
                      type="text"
                      maxlength="5"
                      name="buyr_name"
                      placeholder="김라온"
                      @input="validateName"
                    />
                  </div>
                  <div class="nl_3"></div>
                </div>

                <div class="nl">
                  <div class="nl_1">연락처</div>
                  <div class="nl_2">
                    <!-- <input
                      v-model="loadPhone"
                      class="input"
                      type="text"
                      name="buyr_tel2"
                      placeholder="010-1234-5678"
                      maxlength="13"
                      @input="formatPhoneNumber"
                    /> -->
                    <input
                      v-model="formattedPhone"
                      class="input"
                      type="text"
                      name="buyr_tel2"
                      placeholder="010-1234-5678"
                      maxlength="13"
                      @input="(event) => formatPhoneNumber(event.target.value)"
                    />
                  </div>
                  <div class="nl_3"></div>
                </div>
                <!-- 주소 시작 -->
                <!-- orderData의 subOpts에 delivery_amt 존재 여부로 분기처리 해야함. -->
                <!-- {{ orderData }} -->
                <div
                  v-if="orderData.notSubOpts.cnt !== 0"
                  class="info_notSubOpts"
                >
                  <div class="nl">
                    <div class="nl_1">우편번호</div>
                    <div class="nl_2">
                      <input
                        class="input"
                        type="text"
                        name="deliv_zip_code"
                        placeholder="우편번호"
                        readonly
                        :required="orderData.notSubOpts.cnt !== 0"
                      />
                      <!-- <input
                        class="input"
                        type="text"
                        name="deliv_zip_code"
                        placeholder="(12345)"
                        readonly
                        :required="orderData.notSubOpts.cnt !== 0"
                      /> -->
                    </div>
                    <div class="nl_3">
                      <div class="btn_area">
                        <div @click="detailDaumPostCd">배송지 입력</div>
                      </div>
                    </div>
                  </div>
                  <div class="nl">
                    <div class="nl_1">주소</div>
                    <div class="nl_2">
                      <input
                        class="input"
                        type="text"
                        name="deliv_adr"
                        placeholder="기본 주소"
                        readonly
                        :required="orderData.notSubOpts.cnt !== 0"
                      />
                      <!-- <input
                        class="input"
                        type="text"
                        name="deliv_adr"
                        placeholder="서울특별시 영등포구 여의대로 108"
                        readonly
                        :required="orderData.notSubOpts.cnt !== 0"
                      /> -->
                    </div>
                  </div>
                  <div class="nl">
                    <div class="nl_1">상세 주소</div>
                    <div class="nl_2">
                      <input
                        ref="detailedAddressFocus"
                        v-model="userDetailedAddress"
                        class="input"
                        type="text"
                        name="deliv_adr_dtl"
                        placeholder="상세 주소를 입력해 주세요."
                        :required="orderData.notSubOpts.cnt !== 0"
                        @input="logAddressValues"
                      />
                      <!-- <input
                        v-model="userDetailedAddress"
                        class="input"
                        type="text"
                        name="deliv_adr_dtl"
                        placeholder="파크원타워2 47-48(여의도동)"
                        :required="orderData.notSubOpts.cnt !== 0"
                        @input="logAddressValues"
                      /> -->
                    </div>
                  </div>

                  <div class="nl">
                    <div class="nl_1">배송 요청사항</div>
                    <div class="nl_2">
                      <CustomSelectDliv
                        class="delivery_select"
                        :options="deliveryOpt"
                        default-option="배송 요청사항을 선택해주세요"
                        @update:selected="handleSelectDelivery"
                      />
                      <input
                        v-model="deliveCode"
                        class="input"
                        type="hidden"
                        name="deliv_req"
                        readonly
                      />
                    </div>
                    <div class="nl_3">
                      <input
                        v-if="isDirectInput"
                        v-model="directInputValue"
                        class="input"
                        type="text"
                        name="deliv_req_direct"
                        placeholder="직접 입력"
                        :required="
                          orderData.notSubOpts.cnt !== 0 && isDirectInput
                        "
                      />
                    </div>
                  </div>
                </div>
                <!-- 주소 끝 -->
              </div>
            </div>

            <div class="order_info">
              <div class="info_title">주문 세부 정보</div>
              <div class="info">
                <table class="bbs_table_1">
                  <colgroup>
                    <col width="180px" />
                    <col width="*" />
                    <col width="160px" />
                    <col width="160px" />
                    <col width="160px" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>상품 내역</th>
                      <th>상품 옵션</th>
                      <th class="text_right">상품 금액</th>
                      <th class="text_right">배송비</th>
                      <th class="text_right">주문 금액</th>
                    </tr>
                  </thead>
                  <tbody>
                    <input
                      type="hidden"
                      name="cot_idx"
                      :value="orderData.contentsIdx"
                      readonly
                    />
                    <input
                      type="hidden"
                      name="good_name"
                      :value="orderData.contentsTitle"
                      readonly
                    />
                    <!-- <tr>
                      <td class="bold">콘텐츠</td>
                      <input
                        type="hidden"
                        name="cot_idx"
                        :value="orderData.contentsIdx"
                        readonly
                      />
                      <input
                        type="hidden"
                        name="good_name"
                        :value="orderData.contentsTitle"
                        readonly
                      />
                      <td
                        :value="orderData.contentsTitle"
                        v-html="orderData.contentsTitle"
                      ></td>
                      <td
                        class="text_right"
                        v-html="(contentsAmt ?? 0).toLocaleString() + '원'"
                      ></td>
                      <td class="text_right">0원</td>
                      <td
                        class="text_right"
                        v-html="(contentsAmt ?? 0).toLocaleString() + '원'"
                      ></td>
                    </tr> -->
                    <tr v-if="orderData.subOpts.name != '선택안함'">
                      <td class="bold">콘텐츠</td>
                      <input
                        type="hidden"
                        name="option_idxs"
                        :value="orderData.subOpts.idx"
                        readonly
                      />
                      <input
                        type="hidden"
                        name="option_cnts"
                        :value="orderData.subOpts.cnt"
                        readonly
                      />
                      <input
                        type="hidden"
                        name="option_names"
                        :value="orderData.subOpts.name"
                        readonly
                      />
                      <td
                        v-html="
                          orderData.contentsTitle +
                          ' - ' +
                          orderData.subOpts.name
                        "
                      ></td>
                      <!-- 구매 액수 * 갯수 -->
                      <td
                        v-if="orderData.subOpts.disc_rate !== 0"
                        class="text_right"
                        v-html="
                          (
                            (orderData.subOpts.disc_amt_drt ?? 0) *
                            (orderData.subOpts.cnt ?? 1)
                          ).toLocaleString() + '원'
                        "
                      ></td>
                      <td
                        v-else
                        class="text_right"
                        v-html="
                          (
                            (orderData.subOpts.disc_amt ?? 0) *
                            (orderData.subOpts.cnt ?? 1)
                          ).toLocaleString() + '원'
                        "
                      ></td>
                      <td
                        class="text_right"
                        v-html="
                          (
                            orderData.subOpts.delivery_amt ?? 0
                          ).toLocaleString() + '원'
                        "
                      ></td>
                      <!-- 총 금액 계산 -->
                      <td
                        v-if="orderData.subOpts.disc_rate !== 0"
                        class="text_right"
                        v-html="
                          (
                            (orderData.subOpts.disc_amt_drt ?? 0) *
                              (orderData.subOpts.cnt ?? 1) +
                            (orderData.subOpts.delivery_amt ?? 0)
                          ).toLocaleString() + '원'
                        "
                      ></td>
                      <td
                        v-else
                        class="text_right"
                        v-html="
                          (
                            (orderData.subOpts.disc_amt ?? 0) *
                              (orderData.subOpts.cnt ?? 1) +
                            (orderData.subOpts.delivery_amt ?? 0)
                          ).toLocaleString() + '원'
                        "
                      ></td>
                    </tr>
                    <tr v-if="orderData.notSubOpts.name !== '선택안함'">
                      <td class="bold">추가옵션</td>
                      <input
                        type="hidden"
                        name="option_idxs"
                        :value="orderData.notSubOpts.idx"
                        readonly
                      />
                      <input
                        type="hidden"
                        name="option_cnts"
                        :value="orderData.notSubOpts.cnt"
                        readonly
                      />
                      <input
                        type="hidden"
                        name="option_names"
                        :value="orderData.notSubOpts.name"
                        readonly
                      />
                      <td v-html="orderData.notSubOpts.name"></td>
                      <!-- 구매 액수 * 갯수 -->
                      <td
                        v-if="orderData.notSubOpts.disc_rate !== 0"
                        class="text_right"
                        v-html="
                          (
                            (orderData.notSubOpts.disc_amt_drt ?? 0) *
                            (orderData.notSubOpts.cnt ?? 1)
                          ).toLocaleString() + '원'
                        "
                      ></td>
                      <td
                        v-else
                        class="text_right"
                        v-html="
                          (
                            (orderData.notSubOpts.disc_amt ?? 0) *
                            (orderData.notSubOpts.cnt ?? 1)
                          ).toLocaleString() + '원'
                        "
                      ></td>
                      <td
                        class="text_right"
                        v-html="
                          (
                            orderData.notSubOpts.delivery_amt ?? 0
                          ).toLocaleString() + '원'
                        "
                      ></td>
                      <!-- 총 금액 계산 -->
                      <td
                        v-if="orderData.notSubOpts.disc_rate !== 0"
                        class="text_right"
                        v-html="
                          (
                            (orderData.notSubOpts.disc_amt_drt ?? 0) *
                              (orderData.notSubOpts.cnt ?? 1) +
                            (orderData.notSubOpts.delivery_amt ?? 0)
                          ).toLocaleString() + '원'
                        "
                      ></td>
                      <td
                        v-else
                        class="text_right"
                        v-html="
                          (
                            (orderData.notSubOpts.disc_amt ?? 0) *
                              (orderData.notSubOpts.cnt ?? 1) +
                            (orderData.notSubOpts.delivery_amt ?? 0)
                          ).toLocaleString() + '원'
                        "
                      ></td>
                      <!-- <td
                        v-html="
                          (
                            orderData.notSubOpts.amt ??
                            0 * orderData.notSubOpts.cnt ??
                            0 + orderData.notSubOpts.delivery_amt ??
                            0
                          ).toLocaleString() + '원'
                        "
                      ></td> -->
                    </tr>
                  </tbody>
                </table>

                <div class="pay_info">
                  <div class="pay_top_txt">총 주문금액</div>
                  <div class="ipt-type-1 gap-2 pc-wd-2 pay_price">
                    <!-- 총 콘텐츠 금액 -->
                    <input
                      :value="contentsAmt"
                      type="hidden"
                      name="cot_total_amt"
                      maxlength="12"
                      readonly
                    />
                    <!-- 총 옵션 금액 -->
                    <input
                      :value="optionsAmount"
                      type="hidden"
                      name="option_total_amt"
                      maxlength="12"
                      readonly
                    />
                    <!-- 총 배송비 -->
                    <input
                      :value="deliveryAmount"
                      type="hidden"
                      name="delivery_amt"
                      maxlength="12"
                      readonly
                    />
                    <!-- 총 결재 금액 -->
                    <input
                      :value="totalOrderAmount"
                      type="hidden"
                      name="good_mny"
                      maxlength="12"
                      readonly
                    />
                    <td
                      :value="totalOrderAmount"
                      v-html="totalOrderAmount.toLocaleString() + '원'"
                    ></td>
                    <!-- <td
                      class="ipt-type-1 gap-2 pc-wd-2"
                      :value="totalOrderAmount"
                      v-html="totalOrderAmount + '원'"
                      name="good_mny"
                    ></td> -->
                  </div>
                  <!-- <div class="pay_area">
                  <div>
                    <div class="pay_txt">총 상품 금액</div>
                    <div class="pay_price">
                      <td v-html="optionsAmount.toLocaleString() + '원'"></td>
                    </div>
                  </div>
                  <div>
                    <div class="pay_txt">배송비</div>
                    <div class="pay_price">
                      <span
                        v-html="deliveryAmount.toLocaleString() + '원'"
                      ></span>
                    </div>
                  </div>
                </div> -->
                </div>
              </div>
            </div>

            <div class="pay_type">
              <!-- 
                결제 수단 정보 설정 
                결제에 필요한 결제 수단 정보를 설정합니다.                               
                신용카드 : 100000000000, 계좌이체 : 010000000000, 가상계좌 : 001000000000
                포인트 : 000100000000, 휴대폰 : 000010000000, 상품권 : 000000001000          
                위와 같이 설정한 경우 표준웹에서 설정한 결제수단이 표시됩니다.
                표준웹에서 여러 결제수단을 표시하고 싶으신 경우 설정하시려는 결제
                수단에 해당하는 위치에 해당하는 값을 1로 변경하여 주십시오.

                ※ 필수
                  KCP에 신청된 결제수단으로만 결제가 가능합니다.        
              -->
              <div class="pay_top_txt">결제수단</div>
              <div class="types">
                <div class="radio_area">
                  <input
                    id="radio-2-1"
                    type="radio"
                    class="ipt-radio-1"
                    name="pay_method"
                    value="100000000000"
                    checked
                    readonly
                  />
                  <label for="radio-2-1"
                    ><span class="ico-radio"><span></span></span>신용카드</label
                  >
                  <!-- <input id="pay_1" type="radio" name="pays" value="신용카드" />
                  <name for="pay_1" class="pay_1">신용카드</name> -->
                </div>

                <!--
              <div class="radio_area">
                <input id="pay_2" type="radio" name="pays" value="간편결제"/>
                <name for="pay_2" class="pay_2">간편결제</name>
              </div>
              -->

                <!-- <div class="radio_area">
                  <input
                    id="radio-2-2"
                    type="radio"
                    class="ipt-radio-1"
                    name="pay_method"
                    value="010000000000"
                    readonly
                  />
                  <label for="radio-2-2"
                    ><span class="ico-radio"><span></span></span>계좌이체</label
                  >
                </div> -->

                <!-- <input id="pay_3" type="radio" name="pays" value="계좌이체" />
                 <name for="pay_3" class="pay_3">계좌이체</name> -->

                <!-- <div class="radio_area">
                  <input
                    id="radio-2-3"
                    type="radio"
                    class="ipt-radio-1"
                    name="pay_method"
                    value="001000000000"
                    readonly
                  />
                  <label for="radio-2-3"
                    ><span class="ico-radio"><span></span></span>가상계좌</label
                  >
                </div> -->

                <!-- <input id="pay_4" type="radio" name="pays" value="가상계좌" />
                <name for="pay_4" class="pay_4">가상계좌</name> -->
                <!-- <div class="radio_area">
                  <input id="pay_5" type="radio" name="pays" value="휴대폰" />
                  <name for="pay_5" class="pay_5">휴대폰</name>
                </div> -->
              </div>
            </div>

            <div class="pay_footer">
              <div class="agreement">
                <div>
                  약관 및 주문 내용을 확인하였으며, 정보 제공 등에 동의합니다.
                </div>
                <div @click="moveToWindowUrl('/AgreeTrem')">상세보기 ></div>
              </div>

              <div class="btn_area">
                <!-- <div class="" @click="goBack">취소</div> -->
                <div class="" @click="askAgain()">취소</div>
                <div class="gtm_order" @click="validateDelivMsg()">
                  결제요청
                </div>
              </div>
              <!-- <div class="btn_test_area">
                <div class="test_btn" @click="moveToUrl('/order_failed')">
                  실패테스트
                </div>
              </div> -->
            </div>
            <div>
              <input
                type="hidden"
                name="ordr_idxx"
                maxlength="12"
                value=""
                readonly
              />
              <!-- 가맹점 정보 설정(개발) -->
              <!-- <input type="hidden" name="site_cd" value="T0000" /> -->
              <!-- 가맹점 정보 설정(운영) -->
              <!-- <input type="hidden" name="site_cd" value="AKGK7" /> -->
              <input type="hidden" name="site_cd" :value="kcpSiteCode" />
              <input type="hidden" name="site_name" value="Raon Metademy" />
              <!-- 신용카드 설정 -->
              <input type="hidden" name="quotaopt" value="3" />
              <!-- 최대 할부개월수 -->
              <!-- 
              ※필수 항목
              결제인증 완료 후 결제창에서 값을 설정하는 부분으로 반드시 포함되어야 합니다. 
              임의로 값을 설정하지 마십시오.
            -->
              <input type="hidden" name="res_cd" value="" />
              <input type="hidden" name="res_msg" value="" />
              <input type="hidden" name="enc_info" value="" />
              <input type="hidden" name="enc_data" value="" />
              <input type="hidden" name="tran_cd" value="" />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div>
    <ModalAlertOrderData
      :alertMsg="errMsg"
      :isOpen="errStatus"
      :trigger="errTrigger"
      :isEmpty="inputStatus"
      :goBack="moveBack"
      @update:isOpen="updateStatus"
      @check:isEmpty="focusToDetailAdd"
    />
    <!-- <ModalAlertOrderData
      :alertMsg="errMsg"
      :isOpen="errStatus"
      :trigger="errTrigger"
      :isEmpty="inputStatus"
      :goBack="moveBack"
      @update:isOpen="updateStatus"
      @check:isEmpty="focusToDetailAdd"
/> -->
    <!-- <ModalAlertOrderData
      :alertMsg="errMsg"
      :isOpen="errStatus"
      :trigger="errTrigger"
      :isEmpty="inputStatus"
      :goBack="moveBack"
      @update:isOpen="updateStatus" 
      @check:isEmpty="focusToDetailAdd"
    /> -->
  </div>

  <AddressAdd v-if="showAddressAdd" @close="closeAddressAdd" />
  <AddressList v-if="showAddressList" @close="closeAddressList" />
</template>

<script>
/*
  order_test에서 배송지에 대한 정보도 같이 DB에 저장 된 것을 확인함. 여기서도 동일하게 작업 진행하면 될듯.
 */

import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'

import axios from 'axios'
import { useCookies } from 'vue3-cookies'

import CustomSelectDliv from '../components/CustomSelectDliv.vue'
import { loadDeliveryMsg, loadUserDatas } from '../api/orders'

import AddressAdd from '../components/AddressAdd.vue'
import AddressList from '../components/AddressList.vue'
import ModalAlertOrderData from '../components/ModalAlertOrderData.vue'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Order',
  components: {
    ModalAlertOrderData,
    CustomSelectDliv,
    AddressAdd,
    AddressList,
  },
  setup() {
    const router = useRouter()
    const checkOrdrIdx = ref()
    const storageData = localStorage.getItem('orderData')
    const orderData = JSON.parse(storageData)

    // const datas = route.state.orderData
    // const orderData = route.state.orderData
    const orderCompletedData = ref()
    const hp = ['010', '011', '016', '017', '019']
    const address = ['집', '회사', '헬스장', '내집', '두꺼비집']

    const errMsg = ref('')
    const errStatus = ref(false)
    const inputStatus = ref(false)
    const errTrigger = ref('')
    const moveBack = ref('')

    const loadName = ref('')
    const loadPhone = ref('')
    const userAddress = ref('')
    const userDetailedAddress = ref('')
    const updateStatus = () => {
      errStatus.value = false
    }
    const kcpSiteCode = process.env.VUE_APP_KCP_SITE_CODE
    const kcpJsUrl = process.env.VUE_APP_KCP_JS_URL
    const formattedPhone = ref('')
    const detailedAddressFocus = ref(null)

    const focusToDetailAdd = () => {
      inputStatus.value = false
      if (!userDetailedAddress.value) {
        detailedAddressFocus.value?.focus() // ref가 null일 때를 대비해 안전하게 접근
      } else {
        alert('으아아아아')
      }
    }
    // const detailedAddressFocus = ref(null)
    // // 상세 주소 input에 포커싱
    // const focusToDetailAdd = () => {
    //   inputStatus.value = false
    //   if (!userDetailedAddress.value || userDetailedAddress.value === null) {
    //     detailedAddressFocus.value.focus()
    //   }
    // }
    // 핸드폰 번호 포맷팅 함수
    const formatPhoneNumber = (input) => {
      let phoneNumber = input.replace(/[^0-9]/g, '')
      if (phoneNumber.length > 3 && phoneNumber.length <= 7) {
        phoneNumber = `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`
      } else if (phoneNumber.length > 7) {
        phoneNumber = `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7)}`
      }
      formattedPhone.value = phoneNumber
      loadPhone.value = phoneNumber.replace(/-/g, '') // 하이픈 제거한 상태로 저장

      // let phoneNumber = event.target.value.replace(/[^0-9]/g, '')
      // if (phoneNumber.length > 3 && phoneNumber.length <= 7) {
      //   phoneNumber = phoneNumber.replace(/(\d{3})(\d+)/, '$1-$2')
      // } else if (phoneNumber.length > 7) {
      //   phoneNumber = phoneNumber.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3')
      // }
      // loadPhone.value = phoneNumber
      // // formattedHpNum.value = formatPhoneNumber(event.target.value)
    }

    const loadUsers = async () => {
      const loadData = await loadUserDatas()
      if (loadData) {
        if (loadData.status_code === 200) {
          loadName.value = loadData.content.username
          loadPhone.value = loadData.content.phone
          formatPhoneNumber(loadPhone.value)
          // const setHypenPhone = loadData.content.phone
          // eslint-disable-next-line no-use-before-define
          // loadPhone.value = formatPhoneNumber(setHypenPhone)
        } else if (loadData.status_code === 401) {
          errStatus.value = true
          errTrigger.value = 'orderTrigger'
          errMsg.value = '로그인 후 시도해주세요.'
        } else {
          errStatus.value = true
          errTrigger.value = 'orderTrigger'
          errMsg.value = '비정상적인 접근입니다.'
        }
      }
    }
    // 이름 유효성 검사 (한글만 입력 가능)
    const validateName = (event) => {
      loadName.value = event.target.value.replace(/[^ㄱ-ㅎㅏ-ㅣ가-힣]/g, '')
    }

    const deliveryOpt = ref()

    const delivMsgSetting = async () => {
      const loadData = await loadDeliveryMsg()
      deliveryOpt.value = loadData.content
    }

    const isDirectInput = ref(false)
    const directInputValue = ref('')

    const showAddressAdd = ref(false)
    const showAddressList = ref(false)
    const deliveCode = ref('')
    const handleSelectAddress = (selected) => {
      alert(`선택된 값은: ${selected}`)
    }

    const handleSelectDelivery = (selected) => {
      // alert(`선택된 값은: ${selected.name}`)
      // console.log('요청사항 선택 ::', selected)
      deliveCode.value = selected.code
      isDirectInput.value = selected.code === 'DVR08'
      if (selected.code !== 'DVR08') {
        directInputValue.value = ''
      }
      // console.log('isDirectInput:', isDirectInput.value)
      // console.log('directInputValue:', directInputValue.value)
    }

    const handleSelectHp = (selected) => {
      alert(`선택된 값은: ${selected}`)
    }

    const moveToUrl = (url) => {
      // window.location.href = url
      if (url === '/order_completed') {
        localStorage.removeItem('orderData')
        localStorage.removeItem('redirectIfFailed')
        router.push({ path: url })
      } else {
        router.push({ path: url })
      }
    }

    const moveToWindowUrl = (url) => {
      window.open(url, '_blank')
    }

    const openAddressAdd = () => {
      showAddressAdd.value = true
    }

    const closeAddressAdd = () => {
      showAddressAdd.value = false
    }

    const openAddressList = () => {
      showAddressList.value = true
    }

    const closeAddressList = () => {
      showAddressList.value = false
    }

    // const orderForm = ref(null)
    const detailDaumPostCd = () => {
      // eslint-disable-next-line no-undef
      new daum.Postcode({
        oncomplete(data) {
          const addr =
            data.userSelectedType === 'R' ? data.roadAddress : data.jibunAddress
          userAddress.value = addr
          document.order_info.deliv_adr.value = addr
          document.order_info.deliv_zip_code.value = data.zonecode
          document.order_info.deliv_adr_dtl.focus()
        },
      }).open()
    }

    // 수정 들어가야함.
    const optionsAmount = computed(() => {
      const opt1Cost = ref('')
      const opt2Cost = ref('')
      if (orderData.subOpts?.disc_rate !== 0) {
        opt1Cost.value = orderData.subOpts?.disc_amt_drt ?? 0
        // eslint-disable-next-line no-dupe-else-if
      } else if (orderData.subOpts?.disc_rate !== 0) {
        opt1Cost.value = orderData.subOpts?.disc_amt ?? 0
      }
      if (orderData.subOpts?.disc_rate !== 0) {
        opt2Cost.value = orderData.notSubOpts?.disc_amt_drt ?? 0
        // eslint-disable-next-line no-dupe-else-if
      } else if (orderData.subOpts?.disc_rate !== 0) {
        opt2Cost.value = orderData.notSubOpts?.disc_amt ?? 0
      }
      const opt1Cnt = orderData.subOpts?.cnt ?? 0
      const opt2Cnt = orderData.notSubOpts?.cnt ?? 0
      return opt1Cost.value * opt1Cnt + opt2Cost.value * opt2Cnt
    })
    // // 수정 들어가야함.
    // const optionsAmount = computed(() => {
    //   const opt1Cost = orderData.subOpts?.disc_amt ?? 0
    //   const opt1DrtCost = orderData.subOpts?.disc_amt_drt ?? 0
    //   const opt1Cnt = orderData.subOpts?.cnt ?? 0
    //   const opt2Cost = orderData.notSubOpts?.disc_amt ?? 0
    //   const opt2DrtCost = orderData.notSubOpts?.disc_amt_drt ?? 0
    //   const opt2Cnt = orderData.notSubOpts?.cnt ?? 0
    //   return opt1Cost * opt1Cnt + opt2Cost * opt2Cnt
    // })

    // const optionsAmount = computed(
    //   () =>
    //     orderData.subOpts.amt * orderData.subOpts.cnt +
    //     orderData.notSubOpts.amt * orderData.notSubOpts.cnt
    // )
    const deliveryAmount = computed(() => {
      const opt1Deliv = orderData.subOpts?.delivery_amt ?? 0
      const opt2Deliv = orderData.notSubOpts?.delivery_amt ?? 0

      return opt1Deliv + opt2Deliv
    })
    // const deliveryAmount = computed(
    //   () => orderData.subOpts.delivery_amt + orderData.notSubOpts.delivery_amt
    // )
    const contentsAmt = computed(() => orderData.contentsAmt ?? 0)

    const totalOrderAmount = computed(
      () => optionsAmount.value + deliveryAmount.value + contentsAmt.value
    )

    /* 결제 모듈 붙이기 시작 */
    const { cookies } = useCookies()
    const instance = axios.create({
      baseURL: process.env.VUE_APP_KCP_URL,
    })
    const serializeForm = (form) => {
      const obj = {}
      const formData = new FormData(form)

      formData.forEach((value, key) => {
        // 같은 이름의 필드가 여러 개 있는 경우 배열로 수집
        if (obj[key] !== undefined) {
          if (!Array.isArray(obj[key])) {
            obj[key] = [obj[key]] // 첫 번째 항목을 배열로 변환
          }
          obj[key].push(value) // 새 항목을 배열에 추가
        } else {
          obj[key] = value
        }
      })

      // 라디오 버튼 처리
      const radioButtons = form.querySelectorAll('input[type="radio"]')
      radioButtons.forEach((button) => {
        if (button.checked) {
          obj[button.name] = button.value
        }
      })

      return obj
    }
    // eslint-disable-next-line camelcase
    const jsf__pay = () => {
      try {
        // KCP_Pay_Execute_Web(form)
        // eslint-disable-next-line no-undef
        KCP_Pay_Execute_Web(document.order_info)
      } catch (e) {
        /* IE 에서 결제 정상종료시 throw로 스크립트 종료 */
        console.warn(e)
      }
    }
    const validateDelivMsg = () => {
      console.log(orderData.notSubOpts.cnt)
      // console.log('결제 요청 시도')
      // console.log('주소:', userAddress.value)
      // console.log('상세 주소:', userDetailedAddress.value)
      // console.log('배송 코드:', deliveCode.value)
      // console.log('직접 입력 값:', directInputValue.value)

      // 모바일 디바이스 감지 함수
      // eslint-disable-next-line arrow-body-style
      const isMobileDevice = () => {
        return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      }

      // 모바일 디바이스일 경우 결제 제한
      if (isMobileDevice()) {
        moveBack.value = 'cancel'
        errStatus.value = true
        errMsg.value =
          '모바일 결제는 추후 업데이트 예정입니다.<br> PC 웹사이트에서 결제를 진행해주세요.'
        return // 함수 종료
      }
      if (orderData.notSubOpts.cnt !== 0) {
        if (!userAddress.value) {
          moveBack.value = 'cancel'
          errStatus.value = true
          inputStatus.value = true
          errMsg.value =
            '우편번호(주소)가 입력되지 않았습니다. <br> 우편번호를 입력하면 주소가 자동으로 입력됩니다.'
          // errMsg.value = '배송정보를 모두 입력해주세요.'
        } else if (!userDetailedAddress.value) {
          moveBack.value = 'cancel'
          errStatus.value = true
          inputStatus.value = true
          errMsg.value =
            '상세 주소가 입력되지 않았습니다. <br> 배송 받으실 상세 주소를 입력해 주세요.'
          // errMsg.value = '배송정보를 모두 입력해주세요.'
        } else if (
          !userAddress.value ||
          !userDetailedAddress.value ||
          (deliveCode.value === 'DVR08' && directInputValue.value === '')
        ) {
          moveBack.value = 'cancel'
          errStatus.value = true
          errMsg.value =
            '배송 요청사항이 입력되지 않았습니다. <br> 배송 요청사항을 입력해 주세요.'
          // errMsg.value = '배송정보를 모두 입력해주세요.'
        } else {
          jsf__pay()
        }
      } else {
        jsf__pay()
      }
    }
    // eslint-disable-next-line camelcase
    const init_orderid = async () => {
      try {
        const initResponse = await instance.get('/raonmeta/payment/initOrderId')
        document.order_info.ordr_idxx.value = initResponse.data.orderNo
      } catch (error) {
        console.error('Error:', error)
        // document.order_info.ordr_idxx.value = ''
      }
    }
    const loadKCPScripts = async () => {
      // const url = `${kcpJsUrl}`
      const url = kcpJsUrl
      // 운영
      // const url = 'https://spay.kcp.co.kr/plugin/kcp_spay_hub.js'
      // 개발
      // const url = 'https://testspay.kcp.co.kr/plugin/kcp_spay_hub.js'
      await new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = url
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    }

    // const goBack = () => {
    //   router.go(-1)
    // }
    const askAgain = () => {
      errStatus.value = true
      errMsg.value =
        '입력한 내용이 모두 사라집니다. <br> 주문을 취소하시겠습니까?'
      moveBack.value = 'goBack'
    }
    /* 결제 모듈 붙이기 끝 */
    onMounted(() => {
      window.m_Completepayment = async (FormOrJson, closeEvent) => {
        const frm = document.order_info
        if (checkOrdrIdx.value !== frm.ordr_idxx.value) {
          checkOrdrIdx.value = frm.ordr_idxx.value

          // ********************************************************************/
          //* FormOrJson은 가맹점 임의 활용 금지                               */
          //* frm 값에 FormOrJson 값이 설정 된 frm 값으로 활용 하셔야 됩니다.  */
          // ********************************************************************/
          // eslint-disable-next-line no-undef
          GetField(frm, FormOrJson)
          if (frm.res_cd.value === '0000') {
            try {
              const serializedData = serializeForm(frm)
              const Auth =
                cookies.get('access_token') != null
                  ? cookies.get('access_token')
                  : 'unknown'
              const headers = {
                'Content-Type': 'application/json',
                Authorization: Auth,
              }
              // console.log('serializedData 찍기 :: ', serializedData)
              const optionIdxs = serializedData.option_idxs
              const optionNames = serializedData.option_names
              const optionCnts = serializedData.option_cnts

              const delivZipCode = serializedData.deliv_zip_code
              const delivAddr = serializedData.deliv_adr
              const delivAddrDetail = serializedData.deliv_adr_dtl
              const delivAmt = serializedData.delivery_amt
              const delivReq = serializedData.deliv_req

              const processPaymentLoad = await instance.post(
                '/raonmeta/payment/processPayment',
                serializedData,
                { headers }
              )
              // if(processPaymentLoad.data.resValue3){}
              orderCompletedData.value = {
                orderNum: processPaymentLoad.data.orderNo, // 주문 번호
                userName: processPaymentLoad.data.buyerName, // 사용자(구매자) 이름
                userId: processPaymentLoad.data.buyerId, // 사용자(구매자) ID
                userEmail: processPaymentLoad.data.buyerMail, // 사용자(구매자) Email

                contentsIdx: processPaymentLoad.data.cotIdx, // 구매한 콘텐츠 idx
                contentsTitle: processPaymentLoad.data.goodsName, // 구매한 콘텐츠 명
                // optionsIdxs, optionsNames, optionsCnts는 Array형대로 들어가야함
                optionsIdxs: optionIdxs, // 옵션 ID
                optionsNames: optionNames, // 옵션 이름들
                optionsCnts: optionCnts, // 옵션 구매 갯수
                optionsAmt: serializedData.option_total_amt, // 옵션 총 구매 금액
                totalCostAmt: processPaymentLoad.data.totalAmt, // 총 결제 금액

                deliveryZipCode: delivZipCode, // 배송지 우편번호
                deliveryAddress: delivAddr, // 배송지 주소
                deliveryAddressDetail: delivAddrDetail, // 배송지 상세주소
                deliveryFee: delivAmt, // 배송비
                delivRequest: delivReq, // 배송 요청 메세지 코드

                payMethod: processPaymentLoad.data.payMethod, // 결제 방법(신용카드 or 계좌이체 or 가상계좌)
                pgPayType: processPaymentLoad.data.pgPayType, // 결제 방법 타입(신용카드 PACA or 계좌이체 PACA or 가상계좌 PAVC)
                pgPayMethod: processPaymentLoad.data.pgPayMethod, // 결제 방법 정보 (신용카드 : 100000000000, 계좌이체 : 010000000000, 가상계좌 : 001000000000)\

                resCode: processPaymentLoad.data.resCode, // 결제결과코드(서버단 결과)
                resMsg: processPaymentLoad.data.resMsg, // 결제결과메세지(서버단 결과)

                resValue1: processPaymentLoad.data.resValue1, // 결제 기관
                // 간편결제는 공란, 카드사 결제는 카드번호, 계좌이체는 null, 가상결제는 입금자명 출력됨
                resValue2: processPaymentLoad.data.resValue2,
                resValue3: processPaymentLoad.data.resValue3, // 할부 개월
                resValue4: processPaymentLoad.data.resValue4, // 가상계좌 입금 마감기한
                appTime: processPaymentLoad.data.appTime, // ex) 20240808112339 이렇게 나옴
              }
              // localStorage.setItem('')
              // console.log(processPaymentLoad)
              localStorage.setItem(
                'orderCompletedData',
                JSON.stringify(orderCompletedData.value)
              )
              localStorage.removeItem('orderData')
              // console.log(processPaymentLoad)
              closeEvent()
              // alert(
              //   `[${processPaymentLoad.data.resCode}]${processPaymentLoad.data.resMsg}`
              // )
              // 서버단에서의 결제 성공 실패 분기처리(ex: 결제금액 검증실패, 미로그인 유저 등)
              // 0000만 정상결제
              if (processPaymentLoad.data.resCode === '0000') {
                moveToUrl('/order_completed')
              } else {
                moveToUrl('/order_failed')
              }
              // [TODO] 결과 받아서 처리할 페이지로 값 물고 이동 (이동한 페이지에서 해당 값으로 페이지 구현) -> 뭔말인지 모르겠음 물어보기
              // 참고 테이블 : tb_order_payment
              // 결제수단 : response.payMethod
              // 결제완료 결과값1 : response.resValue1
              // 결제완료 결과값2 : response.resValue2
              // 결제완료 결과값3 : response.resValue3
              // 결제완료 결과값4 : response.resValue4
            } catch (err) {
              console.warn(err)
              // alert(err)
              // alert('[error]')
              closeEvent()
              // window.location.reload(true)
            }
          } else {
            /* 결제인증 실패에 대한 처리 */
            // 프론트 단계 결제 실패 ex) 사용자 취소 등
            // alert(`[${frm.res_cd.value}] ${frm.res_msg.value}`)
            closeEvent()
            // window.location.reload(true)
          }
        } else {
          // eslint-disable-next-line no-useless-return
          return
        }
      }

      loadKCPScripts()
      // eslint-disable-next-line camelcase
      init_orderid()
      delivMsgSetting()
      loadUsers()
      // console.log(kcpJsUrl)
      // console.log(kcpSiteCode)
    })
    const logAddressValues = () => {
      // console.log('현재 주소:', userAddress.value)
      // console.log('현재 상세 주소:', userDetailedAddress.value)
    }
    return {
      logAddressValues,
      errMsg,
      errStatus,
      errTrigger,
      moveBack,
      updateStatus,
      orderData,

      userAddress,
      userDetailedAddress,

      hp,
      address,
      deliveryOpt,
      loadName,
      loadPhone,
      formatPhoneNumber,
      handleSelectAddress,
      handleSelectDelivery,
      isDirectInput,
      directInputValue,
      moveToUrl,
      moveToWindowUrl,
      handleSelectHp,
      showAddressAdd,
      showAddressList,
      openAddressAdd,
      closeAddressAdd,
      openAddressList,
      closeAddressList,

      delivMsgSetting,

      detailDaumPostCd,

      totalOrderAmount,
      deliveryAmount,
      optionsAmount,
      contentsAmt,
      deliveCode,
      // goBack,
      askAgain,
      /* 결제모듈 시작 */
      // eslint-disable-next-line camelcase
      jsf__pay,
      validateDelivMsg,
      /* 결제모듈 끝 */

      kcpSiteCode,
      kcpJsUrl,

      validateName,
      formattedPhone,
      focusToDetailAdd,
    }
  },
}
</script>
